import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=4befd5ae&scoped=true"
import script from "./newsList.vue?vue&type=script&lang=js"
export * from "./newsList.vue?vue&type=script&lang=js"
import style0 from "./newsList.vue?vue&type=style&index=0&id=4befd5ae&prod&lang=scss"
import style1 from "./newsList.vue?vue&type=style&index=1&id=4befd5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4befd5ae",
  null
  
)

export default component.exports